export default __webpack_public_path__ + "static/media/uncertain.274aa7cf.svg";